export const bigScreenBreakpoint = 769;
